import LoginOption from './LoginOption';

export default LoginOption;
